import axios from "../../../axios";

export default {
  fetch() {
    return axios.post("", {
      query: `
        query {
          users {
            id,
            email,
            name,
            image,
            role {
              id,
              name,
              name_pt_br
            },
            social_networks {
              facebook,
              twitter,
              instagram
            }
          }
        }
      `,
    });
  },
  add(user) {
    return axios.post("", {
      query: `
        mutation {
          createUser (
            name: "${user.name}",
            email: "${user.email}",
            password: "${user.password}",
            role_id: ${user.role.id},
            facebook: "${user.social_networks.facebook}",
            twitter: "${user.social_networks.twitter}",
            instagram: "${user.social_networks.instagram}"
          ) {
            user {
              id,
              email,
              name,
              image,
              role {
                id,
                name,
                name_pt_br
              },
              social_networks {
                facebook,
                twitter,
                instagram
              }
            }
          }
        }
      `,
    });
  },
  update(user) {
    return axios.post("", {
      query: `
        mutation {
          updateUser (
            id: ${user.id},
            name: "${user.name}",
            image: "${user.image}",
            email: "${user.email}",
            role_id: ${user.role.id},
            facebook: "${user.social_networks.facebook}",
            twitter: "${user.social_networks.twitter}",
            instagram: "${user.social_networks.instagram}"
          ) {
            user {
              id,
              email,
              name,
              image,
              role {
                id,
                name,
                name_pt_br
              },
              social_networks {
                facebook,
                twitter,
                instagram
              }
            }
          }
        }
      `,
    });
  },
  delete(userId) {
    return axios.post("", {
      query: `
        mutation {
          deleteUser (
            id: ${userId}
          )
        }
      `,
    });
  },
  infos() {
    return axios.post("", {
      query: `
        mutation {
          userInfos {
            user {
              id,
              email,
              name,
              image,
              role {
                id,
                name,
                name_pt_br
              },
              social_networks {
                facebook,
                twitter,
                instagram
              }
            }
          }
        }
      `,
    });
  },
};
